import { TemplateData } from './template.data';

export class TemplatesLibrairie {

  private _data:any;
  private _dico:Array<TemplateData>;

  // ready count
  private _readyCount:number = 0;
  
  constructor(data:any = null) {
    if (data) {
      this.setData(data);
    }
  }

  /**
	 * data
	 */
  public setData(value: any):Promise<boolean> {
    this._data = value;
    this._dico = [];

    return new Promise((resolve, reject) => {
      for (var i:number = 0; i < this._data.length; i++) {
        let tpl:TemplateData = new TemplateData();

        tpl.setData(this._data[i]).then((result: any) => {
            this._readyCount++;
            tpl.computeBase64Border();
            if (this._readyCount >= this._data.length) {
              resolve(true);
            }
          },
          (error: any) => {
            reject(false);
          },
        ).catch((e: Error) => { reject(e); });

        this._dico.push(tpl);
      }

    });
  }

  /**
   * Get value 
   */
  public getById(id:number):TemplateData {
    return this._dico.find((tpl)=>tpl.id===id);
  }

  /**
   * Get value 
   */
  public get length():number {
    return this._data.length;
  }

  /**
   * Cleanup 
   */		
  public cleanup():void {
    for (var i in this._dico) { 
      this._dico[i].cleanup();
    }
    this._dico = null;
    this._data = null;
  }

}
